import React from "react";
import NavigationBar from '../components/nav';

import  '../components/patientdata/demographics/demographics.css'
import GDSForm from '../components/patientdata/gds/gds'
import {Container,Tabs,Tab,Button} from "react-bootstrap";
import Scopa_aut from "../components/patientdata/scopa_aut/scopa_aut"
import Sas from "../components/patientdata/SAS/sas"
import Fab from "../components/patientdata/FAB/fab"
import  Moca from "../components/patientdata/moca/moca";
import Seadl from "../components/patientdata/seadl/seadl";
import Hoehn_yahr from "../components/patientdata/hoehn_yarh/hoehn_yarh"
import Umsars from "../components/patientdata/umsars/umsars";
import PspDs from "../components/patientdata/PSP-DS/psp-ds"
import Updrs from "../components/patientdata/UPDRS/updrs"
import Psp from "../components/patientdata/psp/psp"
import {Redirect} from "react-router-dom"
import app from '../login/firebase'
import axios from "axios";
import ErrorPopup from "../components/utilities/errors/errorPopup"
import RBDQS from "../components/patientdata/RBDQS/rbdqs"
import ImagingBiomarkers from "../components/patientdata/imaging_biomarkers/ImagingBiomarkers"
import ClinicalCriteria from "../components/patientdata/ClinicalCriteriaAndDiagnosis/DiagnosticCriteria/clinicalcriteria"
import PDQ from "../components/patientdata/PDQ/pdq"
import ClinicalAndDiagnosis from "../components/patientdata/ClinicalCriteriaAndDiagnosis/ClinicalAndDiagnosis"
import CurrentTreatment from  "../components/patientdata/demographics/currentTreatment"
import {useHistory} from 'react-router-dom'
import DateOfVisit from "../components/utilities/datePopup/date";
import NMSS from "../components/patientdata/NMSS/nmss";
import MMSE from "../components/patientdata/mmse/mmse";
import Cgi from "../components/patientdata/CGI/cgi";
import CISI from "../components/patientdata/CISI/cisi";
import IPAQ from "../components/patientdata/IPAQ/ipaq";
import MEDAS from "../components/patientdata/MEDAS/medas";
import GCF_TMT from "../components/patientdata/GCF_TMT/gcf_tmt";
import ReorderVisitsPopup from "../components/utilities/reorderVisitsPopup/ReorderVisitsPopup";
class  NewVisit extends React.Component{
    constructor() {
        super();
        this.state ={
            data :{
                
                // demographics:{
                //     personal_info: {},
                //     current_treatment:{},
                //     medical_history:{},
                //     family_history:{}
                // },
                personal_info:{},
                fab:{},
                gds:{},
                hoehn_yarh:{},
                moca:{},
                psp:{},
                psp_cds:{},
                sas:{},
                scopa_aut:{},
                seadl:{},
                umsars:{},
                updrs:{},
                pdq:{},
                medical_notes:{},
                gcf_tmt:{}
            },
            successStatus:false ,
            fetchLink:"",
            mounted:false,
            waitToLoad:true,
            showDatePopup:false,
            disableSubmit:false,
            customVisitNo:null,
            showReorderPopup:false,
            resolvedForVisitNo:null
            
        }
        // this.handleDemographicChange = this.handleDemographicChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChangeWithState = this.handleChangeWithState.bind(this)
    }

    handleDemographicChange = async (field,event) => {
        const {name, value} = event.target
        await this.setState((prevState) => (
                {
                    ...prevState,
                    data:{
                        ...prevState.data,
                        demographics: {
                            ...prevState.data.demographics,
                            [field]:{
                                ...prevState.data.demographics[field],
                                [name] : value
                            }
                        }
                    }
                }
            )
        );

           
    }
    handleDemographicChangeTreatment = async (field,fname,event) => {
        const {name, value} = event.target
        await this.setState((prevState) => (
                {
                    ...prevState,
                    demographics: {
                        ...prevState.demographics,
                        [field]:{
                            ...prevState.demographics[field],
                            [fname]:{
                                ...prevState.demographics[field][fname],
                                [name]:value
                            }
                        }
                    }
                }
            )
        );

    }
    handleChange = async(field,event)=>{
        const {name,value} = event.target
        await this.setState((prevState)=>(
            {
                ...prevState,
                data:{
                    ...prevState.data,
                    [field]:{
                        ...prevState.data[field],
                        [name] : value
                    }
                }
            }
        ))
    }
    async handleChangeWithState(field,income_state){
       
        await this.setState((prevState)=>(
            {
                ...prevState,
                data:{
                    ...prevState.data,
                    [field]:income_state
                }
            }
        ))
        
    }
    handleClinicalPspMsa  = async(field,event)=>{
        // const form  = event.currentTarget
       
       
        if(event.target){
            var {name,value} = event.target
        }
        else{
            var {name,value} = event //articial event
        }
       
         this.setState((prevState)=>(
            {
                ...prevState,
                    data:{
                        ...prevState.data,
                        [field]:{
                            ...prevState.data[field],
                            [name] : value
                        }
                }
            }
        ))
        
    }
    handleImaging = (income_state) =>{
       
        this.setState(prevState=>({data:{...prevState.data,...income_state}}))
    }
   handleVisitNoChange = (val) => {
        this.setState({ customVisitNo: val })
    }

   handleConflict = (visitNo) => {
        this.setState({ showReorderPopup: true })
    }

   handleReorderVisits = async (mapping, setError) => {
        const func = this
        const id = this.props.match.params.id
        await app.auth().currentUser.getIdToken(true).then(async function(idToken) {
            await axios.post(process.env.REACT_APP_reorderVisitsURL,
                { mapping },
                { headers: { 'Content-Type': 'application/json', 'authorization': idToken, 'patient_id': id } }
            ).then(res => {
                if (res.status === 200) {
                    const resolvedNo = parseInt(func.state.customVisitNo || func.props.match.params.visitNo)
                    func.setState({ showReorderPopup: false, resolvedForVisitNo: resolvedNo })
                }
            }).catch(error => {
                if (error.response) {
                    setError("Error " + error.response.status + ": " + (error.response.data || "Request failed."))
                } else {
                    setError("Network error: " + error.message)
                }
            })
        })
    }

   handleSubmit(){
    if (this.state.disableSubmit) return; // prevent double post

    this.setState({ disableSubmit: true }); // disable button after click

    const id = this.props.match.params.id
    const visitNo = this.state.customVisitNo || this.props.match.params.visitNo
    let func = this;

    app.auth().currentUser.getIdToken(true).then(function(idToken){
        axios.post(process.env.REACT_APP_newVisitURL, func.state.data, {
            headers: {
                'Content-Type': 'application/json',
                'authorization': idToken,
                'patient_id': id,
                'visitNo': visitNo
            }
        }).then((response) => {
            if (response.status == 200) {
                func.props.history.push("/");
            } else {
                alert(response.data);
                func.setState({ disableSubmit: false }); // re-enable on failure
            }
        }).catch((err) => {
            alert(err.response?.data || "Submission failed");
            func.setState({ disableSubmit: false }); // re-enable on error
        });
    });
}

   async componentDidMount(){
      
       if(this.props.location.state == undefined){
            this.props.history.push(`/editPatient/${this.props.match.params.id}`)
            return null
       }
    //     fetch("settings.json").then(function(response){
           
    //         return response.json()
    //     }).then( async response=> await this.setState({fetchLink:response["newVisitURL"]}))
        await this.setState({data:this.props.location.state.data,mounted:true})
    }
    componentDidUpdate(prevProps,prevState){
        if (prevState != this.state){
        }
    }
    handleDatePopup = (action) =>{
        if (action == "show"){
            this.setState((prevState)=>(
                {
                    ...prevState,
                    showDatePopup:true
                }
            ))
        }
        else {
            this.setState((prevState)=>(
                {
                    ...prevState,
                    showDatePopup:false,
                    data:{
                        ...prevState.data,
                        visits:{}
                    }
                }
            ))
        }
    }
    handleDate = async (event) =>{
        var {name,value} = event.target
       
        await this.setState((prevState)=>(
            {
                ...prevState,
                    data:{
                        ...prevState.data,
                       visits:{
                           ...prevState.data.visits,
                            [name]:value
                       }
                }
            }
        ),()=>{
            if(value !="" && this.state.patient_id!=""){
                this.setState({disableSubmit:false,checkSubmit:true})
            }
            else{
                this.setState({disableSubmit:true})
            }
        })
    }
    render() {
        if (this.state.successStatus){
            return(
                <Redirect push to={{
                    pathname:'/',
                    state:{subStatus:'success'}
                    
                }}/>
            )
        }else if(this.state.mounted){
        return (
            <div>
                    {/* <NavigationBar newPatient={true} submit={this.handleSubmit} transition={'fade'}/> */}
                    <NavigationBar newPatient={true} submit={this.handleDatePopup} 
                    disableSubmit={this.state.disableSubmit}transition={'fade'}/>

                    <DateOfVisit show={this.state.showDatePopup} handleSubmit={this.handleSubmit} onChange={this.handleDate} handleDatePopup={this.handleDatePopup} disableSubmit={this.state.disableSubmit}
                        defaultVisitNo={this.props.match.params.visitNo}
                        onVisitNoChange={this.handleVisitNoChange}
                        existingVisitNos={this.props.location.state && this.props.location.state.allVisits
                            ? Object.keys(this.props.location.state.allVisits).map(v => parseInt(v.match(/\d+/)[0]))
                            : []}
                        onConflict={this.handleConflict}
                        resolvedForVisitNo={this.state.resolvedForVisitNo}
/>
                    {this.props.location.state && this.props.location.state.allVisits &&
                        <ReorderVisitsPopup
                            show={this.state.showReorderPopup}
                            onHide={() => this.setState({ showReorderPopup: false })}
                            onReorder={this.handleReorderVisits}
                            data={this.props.location.state.allVisits}
                            newVisitTarget={parseInt(this.state.customVisitNo || this.props.match.params.visitNo)}
                        />
                    }


                    <Container fluid className={'container-item'}>
                   
                  
                    <Tabs defaultActiveKey={'diagnosis_diagnostic_criteria'}  >
                       
                    <Tab eventKey={'diagnosis_diagnostic_criteria'} title={"Diagnosis and Diagnostic Criteria"} mountOnEnter>
                            <ClinicalAndDiagnosis 
                            data={
                                {"clinical_psp":this.state.data['clinical_psp'],"clinical_msa":this.state.data['clinical_msa'],"clinical_parkinson_disease":this.state.data['clinical_parkinson_disease'],"diagnosis":this.state.data['diagnosis'],
                                "unclassified_parkinsonism":this.state.data['unclassified_parkinsonism']
                                , 'umsars_new':this.state.data['umsars_new'],"medical_notes":this.state.data['medical_notes']}}handler={this.handleChangeWithState} handler1={this.handleChange} handlePspMsaAuto={this.handleClinicalPspMsa}/>
                        </Tab> 
                        <Tab eventKey={'current_treatment'} title={'Current Treatment'}>
                            <CurrentTreatment data={this.state.data['current_treatment']} handler={this.handleChange}/>
                        </Tab>
                       
                        <Tab eventKey={'hoehn_yahr'} title={'H&Y'} mountOnEnter={true}>
                            <Hoehn_yahr handler={this.handleChangeWithState} data={this.state.data['hoehn_yahr']} />
                        </Tab>
                        <Tab eventKey={'updrs'} title={'UPDRS-IV'}>
                            <Updrs handler={this.handleChangeWithState} mountOnEnter={true} data={this.state.data['updrs']}/>
                        </Tab>
                        <Tab eventKey={'psp'} title={'PSP-RS'}>
                            <Psp handler={this.handleChangeWithState} data={this.state.data['psp']} mountOnEnter={true}/>
                        </Tab>
                        <Tab eventKey={'psp-ds'} title={'PSP-CDS '} mountOnEnter={true}>
                            <PspDs handler={this.handleChangeWithState}  data={this.state.data['psp_cds']} mountOnEnter={true}/>
                        </Tab>
                        <Tab eventKey={'umsars'} title={'UMSARS'} mountOnEnter={true}>
                            <Umsars handler={this.handleChangeWithState} data={this.state.data['umsars']}/>
                        </Tab>
                        <Tab eventKey={'GDS'} title={'GDS'} mountOnEnter={true}>
                            <GDSForm handler={this.handleChangeWithState} data={this.state.data['gds']}/>
                        </Tab>
                        <Tab eventKey={'SCOPA-AUT'} title={'SCOPA-AUT'} mountOnEnter={true}>
                            <Scopa_aut handler={this.handleChangeWithState} data={this.state.data['scopa_aut']} gender={this.props.location.state.gender}/>
                        </Tab>
                        <Tab eventKey={'sas'} title={'SAS'} mountOnEnter={true}>
                            <Sas handler={this.handleChangeWithState}  data={this.state.data['sas']}/>
                        </Tab>
                        <Tab eventKey={'fab'} title={'FAB'} mountOnEnter={true}>
                            <Fab handler={this.handleChangeWithState} data={this.state.data['fab']}/>
                        </Tab>
                        <Tab eventKey={'moca'} title={'MOCA'} mountOnEnter={true}>
                            <Moca handler={this.handleChangeWithState} data={this.state.data['moca']}/>
                        </Tab>
                        <Tab eventKey={'seadl'} title={'SEADL'} mountOnEnter={true}>
                            <Seadl handler={this.handleChangeWithState} data={this.state.data['seadl']}/>
                        </Tab>
                        <Tab eventKey={'rbdsq'} title={'RBDSQ'}mountOnEnter={true}>
                            <RBDQS handler={this.handleChangeWithState} data={this.state.data['rbdsq']}/>

                        </Tab>                 
                        
                      
                        
                        
                        <Tab eventKey={'PDQ'} title={'PDQ-39'}>
                            <PDQ handler={this.handleChangeWithState}  data={this.state.data['pdq']}/>

                        </Tab>
                        <Tab eventKey={'imaging_biomarkers'} title={"Imaging and Biomarkers"}>
                            <ImagingBiomarkers handler={this.handleImaging} data={{"bmri":this.state.data['bmri'],
                                datscan:this.state.data['datscan'],
                                ibzm_spect:this.state.data['ibzm_spect'],
                                mibg_spect:this.state.data['mibg_spect'],
                                polysomnography:this.state.data['polysomnography'],
                                fdg_pet_brain:this.state.data['fdg_pet_brain'],
                                "serum_sample":this.state.data['serum_sample'],
                                "csf_sample":this.state.data['csf_sample'],
                                "pmbcs_exosomes":this.state.data['pmbcs_exosomes']}} />
                        </Tab>
                        <Tab eventKey={'nmss'} title={'NMSS'} mountOnEnter={true}>
                            <NMSS handler={this.handleChangeWithState} data={this.state.data['nmss']} disabled={this.props.preventEdit}/>
                        </Tab>
                        <Tab eventKey={'mmse'} title={"MMSE"} mountOnEnter={true}>
                            <MMSE handler={this.handleChangeWithState} data={this.state.data['mmse']} disabled={this.props.preventEdit}/>
                        </Tab>
                        <Tab eventKey={'cgi'} title={"CGI"} mountOnEnter={true}>
                            <Cgi handler={this.handleChangeWithState} data={this.state.data['cgi']} disabled={this.props.preventEdit}/>
                        </Tab>
                        <Tab eventKey={'CISI'} title={"CISI"} mountOnEnter={true}>
                            <CISI handler={this.handleChangeWithState} data={this.state.data['cisi']} disabled={this.props.preventEdit}/>
                        </Tab>
                        <Tab eventKey={'IPAQ'} title={"IPAQ"} mountOnEnter={true}>
                            <IPAQ handler={this.handleChangeWithState} data={this.state.data['ipaq']} disabled={this.props.preventEdit}/>
                        </Tab>
                        <Tab eventKey={'MEDAS'} title={"MEDAS"} mountOnEnter={true}>
                            <MEDAS handler={this.handleChangeWithState} data={this.state.data['medas']} disabled={this.props.preventEdit}/>
                        </Tab>
                        <Tab eventKey={'gcf_tmt'} title={"GCF / TMT"} mountOnEnter={true}>
                            <GCF_TMT handler={this.handleChangeWithState} data={this.state.data['gcf_tmt']}/>
                        </Tab>

                    </Tabs>
                            
                    </Container>
                   
                   

            </div>
        )
        }
        else{
           
            return(
                <p>Loading</p>
            )
        }
        
    }
}
export default NewVisit;